module.exports = __webpack_public_path__ + "img/Carousel-Beneficios-icono-04.f9bf9750.svg";